import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Github, Linkedin, Twitter } from 'lucide-react';
import { GibsonStratumLogo } from './GibsonStratumLogo';

export const Footer = () => {
  return (
    <footer className="bg-gray-950 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2">
              <GibsonStratumLogo size={36} />
              <span className="font-bold text-xl font-['Outfit']">
                Gibson<span className="text-blue-400">Stratum</span>
              </span>
            </Link>
            <p className="text-gray-400 text-sm">
              Custom software solutions built with precision and security in mind.
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-gray-500 hover:text-blue-400 transition-colors">
                <Github className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-500 hover:text-blue-400 transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-500 hover:text-blue-400 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-white mb-4 font-['Outfit']">Services</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/software" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Free Software
                </Link>
              </li>
              <li>
                <Link to="/estimator" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Project Estimation
                </Link>
              </li>
              <li>
                <Link to="/scanner" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Virus Scanner
                </Link>
              </li>
              <li>
                <Link to="/security" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Security Services
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold text-white mb-4 font-['Outfit']">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white text-sm transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/login" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Developer Portal
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Customer Portal
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-white mb-4 font-['Outfit']">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-gray-400 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-blue-400" />
                <span>20011 Plymouth Rd Ste 333<br />Detroit, Michigan 48228</span>
              </li>
              <li className="flex items-center gap-2 text-gray-400 text-sm">
                <Phone className="w-4 h-4 flex-shrink-0 text-blue-400" />
                <a href="tel:+18556797946" className="hover:text-white transition-colors">
                  888-679-7946
                </a>
              </li>
              <li className="flex items-center gap-2 text-gray-400 text-sm">
                <Mail className="w-4 h-4 flex-shrink-0 text-blue-400" />
                <a href="mailto:contact@gibsonstratum.tech" className="hover:text-white transition-colors">
                  contact@gibsonstratum.tech
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Gibson Stratum. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-gray-500 hover:text-white text-sm transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-500 hover:text-white text-sm transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
